/*
 * Food Türkiye — sepette tahmini kargo satırı (19 Eki 2026).
 * Ülke: Shopify'ın IP tahmini (/browsing_context_suggestions.json).
 * Ücret: Shopify'ın kendi kargo hesabı (cart/shipping_rates.json) — ödeme ekranıyla aynı hesap, sepet ağırlığına göre.
 * Kargo ücreti posta koduna değil ülkeye + ağırlığa bağlı (19 Eki doğrulandı); Shopify posta kodu/il zorunlu tuttuğu için
 * her ülkeye örnek posta kodu/il verilir. Listede olmayan ülke, hata veya boş sepet → satır gizli kalır.
 * Ücretsiz kargo sınırı (tema ayarı, çubukla aynı) aşılınca fiyat yerine "Ücretsiz" yazılır.
 * Sepeti asla engellemez; Shopify kısa sürede çok sorguyu sınırladığı için sonuçlar oturum boyunca önbelleklenir.
 */
(() => {
  if (window.ftShipEstimate) return;
  window.ftShipEstimate = true;

  const SAMPLE = {
    DE: ['10115'], AT: ['1010'], CH: ['8001'], FR: ['75001'], BE: ['1000'], LU: ['1009'], NL: ['1011 AB'],
    IT: ['00118', 'RM'], ES: ['28001', 'M'], PT: ['1100-148', 'PT-11'], IE: ['D02 X285', 'D'], GB: ['SW1A 1AA'],
    PL: ['00-001'], CZ: ['110 00'], SK: ['811 01'], HU: ['1051'], RO: ['010011'], BG: ['1000'], GR: ['105 57'],
    HR: ['10000'], SI: ['1000'], DK: ['1050'], SE: ['111 20'], NO: ['0150'], FI: ['00100'], EE: ['10111'],
    LV: ['LV-1050'], LT: ['01100'], MT: ['VLT 1117'], CY: ['1010'], US: ['10001', 'NY'], CA: ['M5H 2N2', 'ON'],
    AU: ['2000', 'NSW'], NZ: ['1010'], AE: [''], SA: ['11564'], QA: [''], KW: ['13001'], JP: ['100-0001', 'JP-13'],
  };
  const SEL = '[data-ft-ship-estimate]';
  const FREE_RATE_CAP = 250;
  const ATTR = '_ft_kargo_satiri';
  const store = {
    get(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* yok say */ } },
  };

  let countryPromise = null;
  const getCountry = () => {
    if (countryPromise) return countryPromise;
    const cached = store.get('ftShipCountry');
    if (cached !== null) return (countryPromise = Promise.resolve(cached));
    countryPromise = fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => (j && j.detected_values && j.detected_values.country && j.detected_values.country.handle) || '')
      .catch(() => '')
      .then((cc) => { store.set('ftShipCountry', cc); return cc; });
    return countryPromise;
  };

  const countryName = (cc) => {
    try { return new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }).of(cc) || cc; } catch (e) { return cc; }
  };
  const money = (price) => {
    const fmt = (window.theme && theme.settings && theme.settings.moneyWithCurrencyFormat) || '${{amount}} USD';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, price);
  };
  const hideAll = () => document.querySelectorAll(SEL).forEach((el) => { el.hidden = true; });

  let seq = 0;
  async function update() {
    const els = document.querySelectorAll(SEL);
    if (!els.length) return;
    const my = ++seq;
    try {
      const cartUrl = (window.theme && theme.routes && theme.routes.cart) || '/cart';
      const cart = await (await fetch(`${cartUrl}.js`, { credentials: 'same-origin' })).json();
      const min = Number(els[0].dataset.min || 0);
      if (!cart.item_count) { hideAll(); return; }
      const free = min > 0 && cart.total_price >= min;
      const cc = await getCountry();
      const sample = SAMPLE[cc];
      if (!sample) { hideAll(); return; }
      const key = `ftShip|${cc}|${cart.total_weight}|${cart.total_price}`;
      let price = store.get(key);
      if (price === null) {
        const q = `shipping_address[zip]=${encodeURIComponent(sample[0])}&shipping_address[country]=${cc}&shipping_address[province]=${encodeURIComponent(sample[1] || '')}`;
        const r = await fetch(`${cartUrl}/shipping_rates.json?${q}`, { credentials: 'same-origin' });
        if (!r.ok) { hideAll(); return; }
        const data = await r.json();
        const rates = (data && data.shipping_rates) || [];
        if (!rates.length) { hideAll(); return; }
        price = rates.map((x) => x.price).sort((a, b) => Number(a) - Number(b))[0];
        store.set(key, price);
      }
      if (my !== seq) return;
      const shownFree = free && Number(price) <= FREE_RATE_CAP;
      document.querySelectorAll(SEL).forEach((el) => {
        const label = el.querySelector('[data-ft-ship-label]');
        const value = el.querySelector('[data-ft-ship-price]');
        if (!label || !value) return;
        label.textContent = (el.dataset.label || '').replace('[country]', countryName(cc));
        // $100+ : otomatik ücretsiz kargo indirimi $250'ye kadar olan kargo ücretlerini kapsar (indirim ayarı) → "Ücretsiz"
        value.textContent = shownFree ? (el.dataset.free || money('0.00')) : money(price);
        el.hidden = false;
      });
      // Ölçüm (Enes 19 Eki): satırı gören sepete müşterinin görmediği not düşer → siparişte ve yarıda kalan ödemede
      // "_ft_kargo_satiri" olarak kalır; gören/görmeyen satın alma oranı Shopify'dan karşılaştırılır. Değer değişmedikçe istek yok.
      const tag = `${cc} ${shownFree ? 'ucretsiz' : price}`;
      if (!cart.attributes || cart.attributes[ATTR] !== tag) {
        fetch(`${cartUrl}/update.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { [ATTR]: tag } }),
        }).catch(() => {});
      }
    } catch (e) {
      hideAll();
    }
  }

  let timer = null;
  const schedule = (ms = 300) => { clearTimeout(timer); timer = setTimeout(update, ms); };

  // Sepet çekmecesi ürün değişince içeriğini yeniden çizer → yeni çizilen satırı doldur.
  let observed = false;
  const observeDrawer = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || observed) return;
    observed = true;
    new MutationObserver((list) => {
      for (const m of list) {
        for (const n of m.addedNodes) {
          if (n.nodeType === 1 && (n.matches(SEL) || n.querySelector(SEL))) { schedule(); return; }
        }
      }
    }).observe(drawer, { childList: true, subtree: true });
  };

  document.addEventListener('on:cart-drawer:after-open', () => { observeDrawer(); schedule(0); });
  document.addEventListener('on:cart:add', () => schedule());
  document.addEventListener('on:line-item:change', () => schedule());
  const onReady = () => { if (document.querySelector(`${SEL}[data-context="page"]`)) schedule(0); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
